import React from "react";
import { View, Text } from "@react-pdf/renderer";

const money = (n) => `$${Number(n).toFixed(2)}`;

export default function TotalsSection({
  S,
  valorTotal,
  totalNeto,
  totalImpuesto,
  total,
}) {
  return (
    <View style={S.half}>
      <View style={S.totalsBox}>
        <View style={S.totRow}>
          <Text style={S.muted}>Valor Total</Text>
          <Text>{money(valorTotal)}</Text>
        </View>

        <View style={S.totRow}>
          <Text style={S.muted}>Total Neto</Text>
          <Text>{money(totalNeto)}</Text>
        </View>

        <View style={S.totRow}>
          <Text style={S.muted}>Total Impuesto</Text>
          <Text>{money(totalImpuesto)}</Text>
        </View>

        <View style={S.totFinal}>
          <Text>Total</Text>
          <Text>{money(total)}</Text>
        </View>
      </View>
    </View>
  );
}